import { useContext } from "react";
import AdminApp from "./AdminApp";
import App from "./App";
import { AuthContext } from "./Authorization/AuthContext";

// AppSelector chooses between different App components based on
// the authenticated user's account configuration.
export default function AppSelector() {
  const { admin } = useContext(AuthContext);

  const SelectedApp = admin ? AdminApp : App;

  return <SelectedApp />;
}
